import type {DependencyList, EffectCallback} from 'react';
import { useEffect, useRef} from 'react'
import {isEqual} from 'lodash'
import {useDebouncedEffect} from './useDebouncedEffect'
import objectHash from 'object-hash'

export function useDeepCompareMemoize<T>(value: T) {
    const ref = useRef(value)

    if (!isEqual(value, ref.current)) {
        ref.current = value
    }

    return ref.current
}

export default function useDebouncedDeepCompareEffect(effect: EffectCallback, deps: DependencyList, delay: number) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useDebouncedEffect(
        effect,
        deps.map(useDeepCompareMemoize),
        delay
    )
}

export function useDeepCompareEffect(effect: EffectCallback, deps: DependencyList) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(
        effect,
        deps.map(d => objectHash(d))
    )
}
